import React from 'react';
import urls from '../configs/urls'
import { Redirect} from 'react-router'
import '../css/Search.css';
import ls from 'local-storage'
import axios from 'axios';
import Retry from "./Retry";
import Products from "./Products";
import AppBody from "./AppBody";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import update from 'react-addons-update';
class ProductsFromImageClick extends React.Component{
    list =[];
    hasMoreProductToLoad = true;
    content = document.getElementsByClassName("content")[0];
    constructor(props){
        super(props);
        this.state = {
            redirect: false,
            page: 1,
            retry: false,
            error: false,
            error_text: "",
            loading: false,
            products_id:[],
            products: [],
        };
        this.handleScroll = this.handleScroll.bind(this);
    }
    componentWillMount() {
        let products = ls.get("products_id");
        if(products == null || products.length == 0){
            this.props.history.push("/");
        }
        this.setState({products_id:products},()=>{this.getProducts()})
    }

    componentDidMount = () => {
        this.content = document.getElementsByClassName("content")[0];
        this.content.addEventListener("scroll",this.handleScroll,false);
    };

    render() {
        if(this.state.redirect)
            return (<Redirect push to={this.state.url}/>);
        if(this.state.retry)
            return (<Retry url={"/home"} type={"RELOAD"} text={"در اجرای درخواست مشکلی پیش آمده است. لطفا مجددا تلاش کنید."}/>);
        if(this.state.error)
            return (
                <div className="App-body bg-white">
                    <div className={"infoMessage"}>
                        {this.state.error_text}
                    </div>
                    <form onSubmit={this.handleSubmit}>
                        <input type={"submit"} className={"btn submitPhone"} value={"صفحه اصلی"}/>
                    </form>
                </div>
            );
        return (
            <AppBody  loading={this.state.loading} name={"جست و جو"} type={" alice"}>
                <div id={"searchProducts"} style={{top:"10px"}}>
                    <Products products={this.state.products}/>
                </div>
            </AppBody>
        );
    }

    getProducts(){
        this.setState({loading: true});
        let data = {
            page:this.state.page,
            products:this.state.products_id,
            token:ls.get("token"),
        };
        axios.get(urls.baseUrl+urls.getProductsById+"?token="+ls.get("token")+"&products="+this.state.products_id.toString()+"&page="+this.state.page)
            .then(res => {
                console.log("products : ",res.data);
                if(res.data.code == 200){
                    if(res.data.product_list.length === 0)
                        this.hasMoreProductToLoad = false;
                    else
                        this.hasMoreProductToLoad = true;

                    this.setState({
                        products:[...this.state.products, ...res.data.product_list],
                        loading:false},()=>{
                        this.content.addEventListener("scroll",this.handleScroll,false);
                    });
                }
                else{
                    alert(res.data.message())
                }
            })
            .catch(error => {
                console.log(error)
                this.setState({retry:true,loading:false},()=>{
                    this.content.addEventListener("scroll",this.handleScroll,false);
                });
            });
    }
    handleScroll = (event) => {
        if(!this.hasMoreProductToLoad){
            event.target.removeEventListener("scroll", this.handleScroll);
            return;
        }

        if(event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight < 2 && !this.isLoadingMore){
            event.target.removeEventListener("scroll", this.handleScroll);

            this.setState({page:this.state.page+1},() => {
                this.getSearchResult();
            })
        }
    };

}
export default ProductsFromImageClick;
